import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosError } from "axios";
import { ResponseMessage } from "../../common/model/ResponseMessage";
import { RouteAPI, api } from "../../common/service/apiService";
import { storageService } from "../../common/service/storageService";
import { AdministrativeArea, Country } from "../../common/redux/countryActions";

export interface StructureProfile {
    societe: string;
    siret: string;
    email: string;
    plainPassword?: string;
    telephone: string;
    profileImage?: string;
    description: string;
    country: Country;
}

export interface StructureProfileUpdate extends Omit<
    StructureProfile,
    "country" | "email" | "telephone"
> {
    country: string;
}

export interface ProfessionnelProfile {
    nom: string;
    prenom: string;
    email: string;
    plainPassword?: string;
    telephone: string;
    profileImage?: string;
    description: string;
    profession: string[];
    administrativeAreas: AdministrativeArea[];
    country: Country;
}

export interface ProfessionnelProfileUpdate extends Omit<
    ProfessionnelProfile,
    "administrativeAreas" | "country" | "email" | "telephone"
> {
    administrativeAreas: string[];
    country: string;
}

export const postUpdateProfil = createAsyncThunk<any, StructureProfileUpdate>(
    "profil/postUpdate",
    async (data, thunkAPI) => {
        try {
            const response = await api(
                RouteAPI.STRUCTURES + "/" + storageService.getIdWithToken(),
                "PATCH",
                data,
            );
            return response.data;
        } catch (error) {
            return thunkAPI.rejectWithValue(
                error as AxiosError<ResponseMessage>,
            );
        }
    },
);

export const professionnelUpdateProfil = createAsyncThunk<
    any,
    ProfessionnelProfileUpdate
>("profil/postUpdateProfessionnel", async (data, thunkAPI) => {
    try {
        const response = await api(
            RouteAPI.PROFESSIONNELS + "/" + storageService.getIdWithToken(),
            "PATCH",
            data,
        );
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error as AxiosError<ResponseMessage>);
    }
});
